import { render } from "./oracleInfo.vue?vue&type=template&id=06f8aca1&scoped=true"
import script from "./oracleInfo.vue?vue&type=script&lang=js"
export * from "./oracleInfo.vue?vue&type=script&lang=js"

import "./oracleInfo.vue?vue&type=style&index=0&id=06f8aca1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f8aca1"]])

export default __exports__